var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isOpen)?_c('ConfirmDialog',{attrs:{"is-open":"","title":_vm.title,"message":_vm.message,"confirm-label":_vm.confirmLabel,"cancel-label":_vm.cancelLabel,"confirm-only":_vm.confirmOnly,"destructive":_vm.destructive,"size":_vm.size},on:{"cancel":_vm.handleCancel,"confirm":_vm.handleConfirm}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }